module.exports = __webpack_public_path__ + "img/quizz-step-5-1.4eb7e4c1.jpg";